// extracted by mini-css-extract-plugin
export var button = "_ir-0";
export var donut = "_ir-1";
export var donutFill = "_ir-3";
export var donutTrack = "_ir-2";